import {DataContentWrapper} from '@hconnect/common/containers'
import {Iso8601} from '@hconnect/common/types'
import {CardLinkChevron, CardLinkWrapper} from '@hconnect/uikit'
import {CardBox} from '@hconnect/uikit/src/lib2'
import {Box, Grid, Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {RcfaStatusTable} from '../components'
import {DOWNTIME_ANALYTICS_WIDGET_NAMESPACE} from '../consts'
import {useRcfaAvailability} from '../hooks'
import {mapAggregatedStoppageRcfaAvailabilityToRcfaStatusTable} from '../mappers'

interface RcfaTableProps {
  plantId: string
  from: Iso8601
  to: Iso8601
  onCardClick?: () => void
  stoppageListHref?: string
}

export const RcfaStatusTableContainer: React.FC<RcfaTableProps> = ({
  plantId,
  from,
  to,
  onCardClick,
  stoppageListHref
}) => {
  const {t} = useTranslation(DOWNTIME_ANALYTICS_WIDGET_NAMESPACE)
  const {
    data: rcfaData,
    isLoading,
    isError,
    isRefetching,
    refetch
  } = useRcfaAvailability({
    plantId,
    from,
    to
  })

  return (
    <CardLinkWrapper
      href={stoppageListHref}
      data-test-id="rcfa-card-link-to-maintain"
      onClick={onCardClick}
    >
      <CardBox>
        <Box display="flex" flexDirection="row">
          <Box flex={1}>
            <Typography variant="h3">{t('rcfaStatus.cardTitle')}</Typography>
          </Box>
          <CardLinkChevron />
        </Box>
        <DataContentWrapper
          showLoader={isLoading}
          isError={isError}
          isRefetching={isRefetching}
          data={rcfaData}
          retryFunction={() => void refetch()}
          progressSx={{color: 'primary.main'}}
        >
          {rcfaData && (
            <Grid display="flex" justifyContent="space-between" marginTop={2}>
              <RcfaStatusTable
                data={mapAggregatedStoppageRcfaAvailabilityToRcfaStatusTable(rcfaData, t)}
              />
            </Grid>
          )}
        </DataContentWrapper>
      </CardBox>
    </CardLinkWrapper>
  )
}
